/* ADD GROUPS */
export const EDIT_EXAM = "EDIT_EXAM"
export const EDIT_EXAM_SUCCESS = "EDIT_EXAM_SUCCESS"
export const EDIT_EXAM_CLEAN = "EDIT_EXAM_CLEAN"
export const EDIT_EXAM_ERROR = "EDIT_EXAM_ERROR"
